export enum LibrariesRouteNames {
  LIBRARIES_ROOT = 'LibrariesRoot',
  LIBRARIES_LIST = 'LibrariesRoot/List',
  CPG_ITEMS = 'LibrariesRoot/ConsumerPackagedGoods',
  VERIFIED_ITEMS = 'LibrariesRoot/ConsumerPackagedGoods/Verified',
  PENDING_ITEMS = 'LibrariesRoot/ConsumerPackagedGoods/Pending',
}
